import React from "react";
import { type Config, TokenHistoryLabel } from "kadow-jetpack-model";
import CTACard from "./module/CTACard";
import KC_Heading2 from "../../../../designsystem/typography/KC-Heading/KC_Heading2";
import { tt } from "../../../../utils/i18n/i18n";

interface RepeatableCTAsEditorProps {
  acquisitionCTAsToDisplay: TokenHistoryLabel[];
  displayTitles: boolean;
  config: Config;
  setFieldValue: (field: string, value: any) => void;
  setFieldTouched: (field: string, value: any) => void;
}

const RepeatableCTAsEditor: React.FC<RepeatableCTAsEditorProps> = (props) => {
  if (!props.acquisitionCTAsToDisplay.length) {
    return null;
  }

  return (
    <div id="acquisition-cta" className="d-flex flex-column st-gap mt-5">
      {props.displayTitles && (
        <div className="d-flex flex-column st-gap">
          <KC_Heading2 text={tt("cta_editor_heading_3")} />
        </div>
      )}
      {props.acquisitionCTAsToDisplay?.map((cta, idx) => {
        const isSelected = props.config.ctas?.some((c) => c.id === cta);
        return (
          <CTACard
            key={`cta-${cta}-${idx}`}
            ctaId={cta}
            setFieldValue={props.setFieldValue}
            setFieldTouched={props.setFieldTouched}
            config={props.config}
            isSelected={isSelected}
          />
        );
      })}
    </div>
  );
};

export default RepeatableCTAsEditor;
